import template from './filter-date-picker.html';

class FilterDatePickerComponent {
  constructor() {
    this.isPopupOpen = false;
    this.dateFormat = 'yyyy/MM/dd';
    this.openPopup = () => {
      this.isPopupOpen = true;
    };
  }

  $onInit() {
    this.dateSelected = this.selected;
  }

  dateChanged() {
    setTimeout(() => this.updateDate(), 0);
  }
}

export default {
  template,
  controller: FilterDatePickerComponent,
  controllerAs: 'vm',
  bindings: {
    updateDate: '&',
    options: '=',
    selected: '='
  }
};
